import ApiHelper from "./ApiHelper"

export const HanMucApi = {
    getHanMucToanBo: async (payload) => {
        const { ngay } = payload
        let result = await ApiHelper.get(`bot/getHanMucToanBo?ngay=${ngay}`)
        
        return result.data
    },
    saveHanMucToanBo: async (payload) => {
         
        let result = await ApiHelper.post(`bot/saveHanMucToanBo`,payload)
        
        return result.data
    },
    activeHanMucToanBo: async () => {
         
        let result = await ApiHelper.post(`bot/getStatusHanMucToanBo`)
        
        return result.data
    },
    activeHanMucToanBo: async (payload) => {
         
        let result = await ApiHelper.post(`bot/activeHanMucToanBoRest`,payload)
        
        return result.data
    },
    saveHanMucToanBoJson: async (payload) => {
         // 
        let result = await ApiHelper.post(`bot/saveHanMucToanBoJsonRest`,payload)
        
        return result.data
    }
}